export class SeoController {
  constructor($scope, $modal, $rootScope) {
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.modal = $modal;

    this.init();
  }

  init() {
    this.scope.rulesModalOpen = () => {
      this.modal.open({
        templateUrl: '../../views/rules-modal.html',
        controller: 'RulesModalController'
      }).result.catch(angular.noop);
    };
  }
}
